import { render, staticRenderFns } from "./ClientCategory.vue?vue&type=template&id=36f033c0&"
import script from "./ClientCategory.vue?vue&type=script&lang=js&"
export * from "./ClientCategory.vue?vue&type=script&lang=js&"
import style0 from "./ClientCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports